import React, { Box, Flex, Grid, Heading, Image } from '@chakra-ui/react';

import ChainIndicators from 'ui/home/indicators/ChainIndicators';
import LatestBlocks from 'ui/home/LatestBlocks';
import LatestSource from 'ui/home/LatestSource';
import LatestTasks from 'ui/home/LatestTasks';
import Stats from 'ui/home/Stats';
import Transactions from 'ui/home/Transactions';

import ProviderStats from './providerViews/providerStats';

const Home = () => {
  return (
    <Box
      as="main"
      marginTop={{
        base: '10',
        lg: '0',
      }}
    >
      <Flex
        flexDir={{
          base: 'column',
          lg: 'row',
        }}
        gap={{
          base: '24px',
        }}
      >
        <Flex flexDir="column" width={{ base: '100%', lg: '50%' }}>
          <Box>
            <Stats/>
          </Box>
          <Box mt={ 4 }>
            <ChainIndicators/>
          </Box>
        </Flex>

        { /* Provider Stats */ }
        <Box width={{ base: '100%', lg: '50%' }}>
          <ProviderStats/>
        </Box>
      </Flex>

      { /* Custom Banner */ }
      <Box
        w="100%"
        bgGradient="linear(to-r, whiteAlpha.900, blue.50)"
        borderBottomWidth="1px"
        borderColor="gray.200"
        h="64px"
        borderRadius="lg"
        boxShadow="sm"
        mt={ 6 }
        _dark={{
          bgGradient: 'linear(to-r, blackAlpha.800, blue.900)',
          borderColor: 'gray.900',
        }}
        overflow="hidden"
      >
        <Flex
          h="100%"
          position="relative"
          justify="space-between"
          align="center"
        >
          <Box pl={ 6 }>
            <Heading
              size="lg"
              fontWeight="semibold"
              textShadow="0 1px 2px rgba(0,0,0,0.05)"
              display="flex"
              alignItems="baseline"
              fontSize={{
                base: 'sm',
                lg: '2xl',
              }}
            >
              OpenGPU Explorer
            </Heading>
          </Box>
          <Image
            src="/assets/banner-logo.png"
            alt="Banner Logo"
            h="64px"
            position="absolute"
            top={ 0 }
            right={ 0 }
            borderTopRightRadius="lg"
            borderBottomRightRadius="lg"
          />
        </Flex>
      </Box>

      { /* Top Section - Blocks and Sources */ }
      { /* <Flex
        flexDir={{ base: 'column', lg: 'row' }}
        mt={6}
        gap={{
          base: '3',
        }}
      > */ }
      <Grid
        templateColumns={{ base: '1fr', md: '1fr', lg: '1fr 1fr' }}
        gap={{ base: '24px' }}
        mt={{ base: '24px' }}
        mb={{ base: '24px' }}
      >
        <LatestBlocks/>
        <LatestSource/>
      </Grid>
      { /* </Flex> */ }
      { /* Bottom Section - Transactions and Tasks */ }
      { /* <Flex gap={3} width="100%" mt={6} flexDir={{ base: 'column', lg: 'row' }}> */ }
      <Grid
        templateColumns={{ base: '1fr', md: '1fr', lg: '1fr 1fr' }}
        gap={{ base: '24px' }}
      >
        <Transactions/>
        <LatestTasks/>
      </Grid>
      { /* </Flex> */ }
    </Box>
  );
};

export default Home;
